<template lang="pug">
	.goal-scorers
		span.goal(
			v-for="goal in goals"
			:class="getGoalTypeClasses(goal)"
		)
			span.goal-time(
				v-if="goal.time"
			)
				timestamp(
					:time="goal.time"
				)
			span.goal-player {{ goal.player ? goal.player.name : '?' }}
			span.goal-type(
				v-if="goal.goalType && !(goal.action === 'goal' && goal.goalType === 'normal') "
			)  {{ getGoalTypeAbbreviation(goal) }}

</template>

<script>
import Timestamp from '@custom-media/ksv-liveticker-shared/src/components/Timestamp'
export default {
	components: {
		Timestamp
	},
	props: {
		goals: Array
	},
	methods: {
		getGoalTypeClasses (goal) {
			var classes = [`is-${goal.action}`]
			if (goal.goalType) {
				classes.push(`is-${goal.goalType}-goal-type`)
			}
			return classes
		},
		getGoalTypeAbbreviation (goal) {
			if (goal.action === 'own-goal') {
				return '(ET)'
			} else if (goal.action === 'goal' && goal.goalType === 'handball-penalty') {
				return '(HE)'
			} else if (goal.action === 'goal' && goal.goalType === 'foul-penalty') {
				return '(FE)'
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	.goal-scorers {
		text-shadow: none;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		.goal {
			margin-right: 1rem;
			margin-bottom: 0.2rem;
			font-size: 1rem;

			.goal-time {
				padding-right: 0.2rem;
			}
		}
		@media screen and (max-width: 768px) {
			flex-direction: column;
			align-items: center;
			.goal {
				font-size: 0.6rem;
				margin-bottom: 0;
				margin-right: 0;

			}
		}
	}
</style>
